export default "__VITE_ASSET__DIv75xLs__"